<template>

  <div class="row" ref="groupForm">

    <div class="col-xs-8 offset-xs-2 col-md-8 offset-md-2 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">

        <card>
          <div slot="header">
            <h4 class="card-title">
              {{ formTitle }}
            </h4>
          </div>

          <div class="card-body">
            <ValidationProvider
              vid="name"
              rules="required"
              name="The name"
              v-slot="{ passed, failed,errors }">
              <fg-input type="text"
                        :error="failed ? errors[0]: null"
                        label="Group Name"
                        name="name"
                        @keyup="generateSomIdent"
                        fou
                        v-model="formData.name">
              </fg-input>
            </ValidationProvider>

            <ValidationProvider
              vid="ident"
              rules="required"
              name="The ident"
              v-slot="{ passed, failed,errors }">
              <fg-input type="text"
                        :error="failed ? errors[0]: null"
                        :disabled="editMode === true"
                        label="Group Ident"
                        name="name"
                        fou
                        v-model="formData.ident">
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              vid="forum_id"
              rules="required"
              name="The Forum"
              v-slot="{ passed, failed,errors }">
              <fg-select
                name="forum_id"
                size="large"
                filterable
                clearable
                placeholder="Forum"
                :error="failed ? errors[0]: null"
                :input-classes="'select-default'"
                :label="'Forum'"
                :list="forumList"
                :listItemLabel="'title'"
                :listItemValue="'id'"
                v-model="formData.forum_id">
              </fg-select>
            </ValidationProvider>

          </div>

          <div class="card-footer text-right">
            <l-button :disabled="entityNotFoundError || submitting" @click.prevent="handleSubmit(submit)"
                      nativeType="submit"
                      type="info" wide>Submit
            </l-button>
            <l-button @click="$router.push('/panel-groups/list')" type="danger" wide>Cancel
            </l-button>
          </div>
        </card>


      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import {extend} from "vee-validate";
import FgSelect from "@/components/Inputs/formGroupSelect";

extend("required", {
  message: "{_field_} is required"
});

export default {
  components:{
    FgSelect,
  },
  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,

      formTitle: "",
      entityNotFoundError: false,
      submitting: false,

      formData: {
        name: "",
        ident: "",
        forum_id: '',
      },
      forumList: [],
    };
  },
  mounted() {

    this.loader = this.$loading.show({
      container: this.$refs.groupForm
    });

    this.axios.post("panel-groups/builder").then((response) => {

      this.forumList = response.data.forumList;
      this.id = this.$route.params['id'];
      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Group";
        this.getGroup();
      } else {
        this.editMode = false;
        this.formTitle = "Add Group";
        this.loader.hide();
        if (response.data.currentForum){
          this.formData.forum_id = response.data.currentForum.id;
        }
      }

    }).catch((error) => {
      console.error(error);
    })


  },


  methods: {
    generateSomIdent() {
      if (!this.editMode) {
        let newUrl = '';
        if (this.formData.name) {
          newUrl = this.formData.name.replace(/\s+/g, "-").toLowerCase();
          newUrl = newUrl.replace(/[^ءأ-يa-zA-Z0-9-]/g, "");
          newUrl = newUrl.replace(/([-]+)/g, "_");
        }
        this.formData.ident = newUrl;
      }
    },
    getGroup() {
      let data = {
        'id': this.id,
      };
      this.axios.post("panel-groups/get", data).then((response) => {
        this.formData = response.data;
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Group Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      this.submitting = true;

      if (this.editMode === true) {
        request = this.axios.put("panel-groups/update/" + this.id, this.formData);
        successMessage = "Group Updated Successfully";
      } else {
        request = this.axios.post("panel-groups/create", this.formData);
        successMessage = "Group Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/panel-groups/list");
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
        } else {

        }
      }).finally(() => {
        this.submitting = false;
      })
    }

  }
}
</script>

<style>
</style>
